/* ==========================================================================
   UNISTELLAR - Ventes privées 2026 - ouverture du Typeform
   Fichier additif.

   Le script d'embed et sa feuille de style ne sont chargés qu'au premier clic
   sur un CTA, pas au chargement de la page. Objectif : ne pas payer le coût
   réseau et JS de l'embed sur le LCP, puisque le doc de campagne exige des
   Core Web Vitals optimisés.

   IMPORTANT : embed.js n'embarque pas son CSS quand on passe par l'API JS
   (tf.createPopup). Sans popup.css, le conteneur .tf-v1-popup reste en
   position: static, se rend en bas du document donc invisible, alors que le
   script pose overflow: hidden sur le body. Résultat : la page se verrouille
   sans que rien n'apparaisse. Les deux ressources sont donc chargées, et on
   attend les deux avant d'ouvrir.

   Filet de sécurité : après ouverture, on vérifie que la popup est bien en
   position fixed. Sinon on déverrouille le body, on retire la popup et on
   redirige vers le formulaire. Un lead n'est jamais perdu et la page ne
   reste jamais bloquée.

   Les paramètres de tracking présents dans l'URL de la page (utm_*, et les
   variables dynamiques META campaign_id / adset_id / ad_id / placement) sont
   transmis au formulaire en champs cachés, pour conserver le dispositif de
   suivi mis en place par Laura.
   ========================================================================== */
(function () {
  'use strict';

  var EMBED_JS = 'https://embed.typeform.com/next/embed.js';
  var EMBED_CSS = 'https://embed.typeform.com/next/css/popup.css';
  var HIDDEN_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'campaign_id', 'adset_id', 'ad_id', 'placement'
  ];

  var assetsReady = null; // Promise, créée au premier clic

  function collectHidden() {
    var params = new URLSearchParams(window.location.search);
    var hash = new URLSearchParams((window.location.hash || '').replace(/^#/, ''));
    var hidden = {};
    HIDDEN_KEYS.forEach(function (k) {
      var v = params.get(k) || hash.get(k);
      if (v) hidden[k] = v;
    });
    // Marche, pose par la section et non par l'URL. Les deux boutiques
    // partagent le meme formulaire : sans cette cle, rien ne distingue un lead
    // US d'un lead EU dans Mailchimp. Inerte tant que la section ne porte pas
    // l'attribut, et tant que le champ cache n'est pas declare cote Typeform.
    var marketNode = document.querySelector('[data-ps-market]');
    var market = marketNode && marketNode.getAttribute('data-ps-market');
    if (market) hidden.market = market;
    return hidden;
  }

  // URL de confirmation, avec report des parametres de tracking.
  //
  // Sans ce report, l'arrivee sur la page de confirmation se fait avec
  // form.typeform.com en referent : GA4 ouvre alors une nouvelle session
  // attribuee a un referral, et la campagne META perd son attribution. On
  // repasse donc les memes cles que celles transmises au formulaire.
  function confirmationUrl() {
    var base = (document.querySelector('[data-ps-confirm-url]') || {}).getAttribute
      ? document.querySelector('[data-ps-confirm-url]').getAttribute('data-ps-confirm-url')
      : '';
    if (!base) return null;
    var hidden = collectHidden();
    var keys = Object.keys(hidden);
    if (!keys.length) return base;
    var sep = base.indexOf('?') === -1 ? '?' : '&';
    return base + sep + keys.map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(hidden[k]);
    }).join('&');
  }

  function goToConfirmation() {
    var url = confirmationUrl();
    if (!url) return;               // pas d'URL configuree : on laisse l'ecran de fin Typeform
    unlockBody();
    window.location.href = url;
  }

  function redirect(formId) {
    var hidden = collectHidden();
    var url = 'https://form.typeform.com/to/' + formId;
    var pairs = Object.keys(hidden).map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(hidden[k]);
    });
    if (pairs.length) url += '#' + pairs.join('&');
    window.location.href = url;
  }

  function unlockBody() {
    // Le script Typeform verrouille le scroll. Si la popup n'est pas
    // exploitable, il faut impérativement le rendre.
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  function loadStylesheet() {
    return new Promise(function (resolve) {
      if (document.querySelector('link[data-ps-tf-css]')) return resolve(true);
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = EMBED_CSS;
      l.setAttribute('data-ps-tf-css', '');
      l.onload = function () { resolve(true); };
      l.onerror = function () { resolve(false); };
      document.head.appendChild(l);
      // ne jamais bloquer indéfiniment sur le CSS
      setTimeout(function () { resolve(false); }, 5000);
    });
  }

  function loadScript() {
    return new Promise(function (resolve) {
      if (window.tf && typeof window.tf.createPopup === 'function') return resolve(true);
      var s = document.createElement('script');
      s.src = EMBED_JS;
      s.async = true;
      s.onload = function () { resolve(true); };
      s.onerror = function () { resolve(false); };
      document.head.appendChild(s);
    });
  }

  function verifyOrRecover(formId) {
    // La popup est créée de façon asynchrone : on laisse au script le temps
    // de l'insérer avant de juger.
    setTimeout(function () {
      var el = document.querySelector('.tf-v1-popup');
      if (!el) {
        unlockBody();
        redirect(formId);
        return;
      }
      if (getComputedStyle(el).position !== 'fixed') {
        // CSS absent ou bloqué : la popup est inutilisable et le body verrouillé.
        el.remove();
        unlockBody();
        redirect(formId);
      }
    }, 600);
  }

  function open(formId) {
    if (!window.tf || typeof window.tf.createPopup !== 'function') {
      redirect(formId);
      return;
    }
    try {
      window.tf.createPopup(formId, {
        hidden: collectHidden(),
        size: 100,
        medium: 'shopify-early-access',
        // La popup est un iframe : une redirection reglee dans Typeform
        // s'appliquerait a l'iframe et afficherait la page de confirmation
        // dans un cadre, avec la page de capture derriere. C'est donc la
        // fenetre parente qui navigue, depuis ici.
        onSubmit: function () { goToConfirmation(); }
      }).open();
      verifyOrRecover(formId);
    } catch (e) {
      unlockBody();
      redirect(formId);
    }
  }

  function handle(formId) {
    if (!assetsReady) {
      assetsReady = Promise.all([loadStylesheet(), loadScript()]);
    }
    assetsReady.then(function (results) {
      var scriptOk = results[1];
      if (!scriptOk) { redirect(formId); return; }
      open(formId);
    });
  }

  /* ------------------------------------------------------------------------
     Slider du ciel

     Pas de librairie : le defilement est natif, avec scroll-snap. Ce bloc
     n'ajoute que les commandes et le rail de progression, et se contente de
     lire l'etat du conteneur. Si le JS ne s'execute pas, le slider reste
     utilisable au geste et au clavier.
     ------------------------------------------------------------------------ */
  function initSlider(root) {
    var track = root.querySelector('[data-ps-track]');
    var prev = root.querySelector('[data-ps-prev]');
    var next = root.querySelector('[data-ps-next]');
    var thumb = root.querySelector('[data-ps-progress]');
    if (!track) return;

    function items() {
      return Array.prototype.slice.call(track.querySelectorAll('.ps-sky__item'));
    }

    // Position de defilement qui cale un element sur son point d'ancrage.
    // Les elements sont en scroll-snap-align: center, d'ou le centrage.
    // Calcul par rapport a la piste plutot que par offsetLeft, qui depend de
    // l'offsetParent et peut etre fausse par un ancetre positionne.
    function targetFor(item) {
      var t = track.getBoundingClientRect();
      var r = item.getBoundingClientRect();
      var left = r.left - t.left + track.scrollLeft;
      return Math.round(left - (track.clientWidth - r.width) / 2);
    }

    function currentIndex() {
      var list = items(), best = 0, bestDist = Infinity;
      list.forEach(function (it, i) {
        var d = Math.abs(targetFor(it) - track.scrollLeft);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    // On vise un point d'ancrage precis. Un simple delta sur scrollLeft est
    // annule par scroll-snap-type: mandatory, qui recale le conteneur avant la
    // fin de l'animation.
    //
    // Les elements en bout de serie partagent la meme position d'ancrage : le
    // premier et le deuxieme valent tous deux 0, puisqu'on ne peut pas centrer
    // un element contre le bord. Sans la boucle ci-dessous, le premier clic ne
    // produirait aucun mouvement.
    function go(direction) {
      var list = items();
      if (!list.length) return;
      var max = track.scrollWidth - track.clientWidth;
      var current = track.scrollLeft;
      var left = null;

      for (var n = currentIndex() + direction; n >= 0 && n < list.length; n += direction) {
        var t = Math.max(0, Math.min(max, targetFor(list[n])));
        if (Math.abs(t - current) > 2) { left = t; break; }
      }
      if (left === null) left = direction > 0 ? max : 0;

      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        track.scrollLeft = left;
      }
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var visible = track.clientWidth / track.scrollWidth;
      if (thumb) {
        var railW = thumb.parentElement.clientWidth;
        var w = Math.max(visible * railW, 32);
        thumb.style.setProperty('--ps-thumb-w', w + 'px');
        var travel = railW - w;
        var ratio = max > 0 ? track.scrollLeft / max : 0;
        thumb.style.setProperty('--ps-thumb-x', Math.round(ratio * travel) + 'px');
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });

    window.addEventListener('resize', update);
    // les visuels sont en lazy : la largeur totale bouge a mesure qu'ils arrivent
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  }

  /* ------------------------------------------------------------------------
     Video Vimeo, en facade

     L'iframe n'est montee qu'a l'approche de la section, et jamais au rendu de
     page : un embed Vimeo charge plusieurs centaines de kilo-octets et du JS
     tiers, ce que le budget Core Web Vitals de la campagne ne permet pas.

     Par defaut, lecture muette en boucle sans controles : le plan dure quinze
     secondes, c'est une boucle de demonstration, pas un film. Si la personne a
     demande a reduire les animations, rien ne demarre tout seul : l'affiche
     reste, et le bouton monte le lecteur avec ses controles.
     ------------------------------------------------------------------------ */
  function mountVideo(node, withControls) {
    if (node.querySelector('iframe')) return;
    var id = node.getAttribute('data-ps-video');
    if (!id) return;
    var params = withControls
      ? 'autoplay=1&dnt=1'
      : 'background=1&autoplay=1&loop=1&muted=1&autopause=0&dnt=1';
    var frame = document.createElement('iframe');
    frame.src = 'https://player.vimeo.com/video/' + id + '?' + params;
    frame.title = node.getAttribute('data-ps-video-title') || '';
    frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    frame.setAttribute('loading', 'lazy');
    node.appendChild(frame);
    node.classList.add('is-playing');
  }

  // Video auto-hebergee : la source n'est posee qu'a l'approche, sinon le
  // navigateur telecharge le fichier des le rendu malgre preload="none" sur
  // certaines versions.
  function mountNative(node, reduce) {
    var video = node.querySelector('video');
    if (!video || video.dataset.psMounted) return;
    var source = video.querySelector('source[data-src]');
    if (source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
    }
    video.dataset.psMounted = '1';
    video.load();
    if (reduce) {
      video.controls = true;
      return;
    }
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      // certains navigateurs refusent la lecture auto : on retombe sur les controles
      p.catch(function () { video.controls = true; });
    }
  }

  function initNativeVideos() {
    var nodes = document.querySelectorAll('[data-ps-video-native]');
    if (!nodes.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (n) { mountNative(n, reduce); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        mountNative(entry.target, reduce);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' });
    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
  }

  function initVideos() {
    initNativeVideos();
    var nodes = document.querySelectorAll('[data-ps-video]');
    if (!nodes.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // le bouton reste utilisable dans tous les cas
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ps-video-play]');
      if (!btn) return;
      var node = btn.closest('[data-ps-video]');
      if (node) mountVideo(node, true);
    });

    if (reduce || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        mountVideo(entry.target, false);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' });

    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
  }

  /* ------------------------------------------------------------------------
     Modale de comparaison

     Sur <dialog> natif : le navigateur gere Echap, le fond, le focus et son
     retour a l'ouvrant. Un piege a focus fait main couterait cent lignes pour
     un resultat moins fiable.
     ------------------------------------------------------------------------ */
  function initCompare() {
    var dialogs = document.querySelectorAll('[data-ps-compare]');
    if (!dialogs.length) return;

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-ps-compare-open]');
      if (openBtn) {
        var root = openBtn.closest('section') || document;
        var dlg = root.querySelector('[data-ps-compare]') || document.querySelector('[data-ps-compare]');
        if (!dlg) return;
        if (typeof dlg.showModal === 'function') {
          dlg.showModal();
        } else {
          // navigateur sans <dialog> : on garde la table accessible en flux
          dlg.setAttribute('open', '');
        }
        return;
      }
      var closeBtn = e.target.closest('[data-ps-compare-close]');
      if (closeBtn) {
        var d = closeBtn.closest('[data-ps-compare]');
        if (d) { if (typeof d.close === 'function') d.close(); else d.removeAttribute('open'); }
        return;
      }
      // clic sur le fond : <dialog> ne le fait pas de lui-meme
      var dlgHit = e.target.closest('[data-ps-compare]');
      if (dlgHit && e.target === dlgHit) {
        if (typeof dlgHit.close === 'function') dlgHit.close();
      }
    });
  }

  function initSliders() {
    document.querySelectorAll('[data-ps-slider]').forEach(initSlider);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSliders(); initVideos(); initCompare(); });
  } else {
    initSliders();
    initVideos();
    initCompare();
  }
  // l'editeur de theme re-rend la section sans recharger la page
  document.addEventListener('shopify:section:load', function () { initSliders(); initVideos(); initCompare(); });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ps-open]');
    if (!trigger) return;
    var formId = trigger.getAttribute('data-ps-form');
    if (!formId) return;
    e.preventDefault();
    handle(formId);
  });
})();
